import React from 'react'
import WysiwygEditor from '../shared/wysiwyg-editor'

function WysiwygWithUpload ({
  initialContent,
  hiddenFieldId,
  placeholder,
  height
}) {
  const handleImageUpload = async file => {
    const formData = new FormData()
    formData.append('image', file)

    // Get event ID from the current page URL or form action
    const currentUrl = window.location.pathname
    const form = document.querySelector('form')
    const formAction = form ? form.getAttribute('action') : ''


    // Try to extract event ID from current URL first (edit page)
    let eventMatch = currentUrl.match(/\/events\/([^\/]+)\/edit/)
    let eventId = eventMatch ? eventMatch[1] : null

    // If not found, try form action
    if (!eventId && formAction) {
      eventMatch = formAction.match(/\/events\/([^\/]+)/)
      eventId = eventMatch ? eventMatch[1] : null
    }


    if (eventId && eventId !== 'new') {
      formData.append('event_id', eventId)
    } else {
      // For new events, we can't upload images until the event is saved
      alert('Please save the event first before adding images to the content.')
      return null
    }

    try {
      const response = await fetch('/images', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: formData
      })

      const data = await response.json()

      if (data.success) {
        return data.url
      } else {
        alert('Failed to upload image: ' + (data.error || 'Unknown error'))
        return null
      }
    } catch (error) {
      alert('Error uploading image: ' + error.message)
      return null
    }
  }

  return (
    <WysiwygEditor
      initialContent={initialContent}
      hiddenFieldId={hiddenFieldId}
      placeholder={placeholder}
      height={height}
      onImageUpload={handleImageUpload}
    />
  )
}

export default WysiwygWithUpload
